const getActiveFieldsFromPopupTemplate = (fields,popupTemplate) => {
    let popupFields=[]
    let popupFieldObject={}
popupTemplate.fieldInfos.forEach(field=>{
    if(field?.visible){
        popupFieldObject[field.fieldName]={
            label:field.label,
            format:field.format
        }
    }
})

fields.forEach(field=>{
    if(popupFieldObject.hasOwnProperty(field.name)){
    popupFieldObject[field.name].alias=field?.alias
    popupFieldObject[field.name].defaultValue=field?.defaultValue
    popupFieldObject[field.name].name=field?.name
    popupFieldObject[field.name].description=field?.description
    popupFieldObject[field.name].domain=field?.domain
    popupFieldObject[field.name].editable=field?.editable
    popupFieldObject[field.name].length=field?.length
    popupFieldObject[field.name].nullable=field?.nullable
    popupFieldObject[field.name].type=field?.type
    popupFieldObject[field.name].valueType=field?.valueType
    popupFields.push(popupFieldObject[field.name])
   }
})
return popupFields
}

export default getActiveFieldsFromPopupTemplate